import * as React from 'react';
import { FormControl, InputLabel, Select, FilledInput, Input, OutlinedInput, MenuItem, Checkbox, ListItemText, FormHelperText } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import '@babel/runtime/helpers/toConsumableArray';
import { useSafeId } from '../../hooks/useSafeId/useSafeId.hook.js';
import { archerConstants } from '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material/styles';
import 'uuid/v4';
var styles = {
  labelStyleHidden: {
    display: 'none'
  },
  selected: {
    '&:hover': {
      backgroundColor: archerConstants.archerHover
    }
  }
};

var CheckboxMultiSelect = function CheckboxMultiSelect(_ref) {
  var _ref$inputLabel = _ref.inputLabel,
      inputLabel = _ref$inputLabel === void 0 ? 'select-label' : _ref$inputLabel,
      helperText = _ref.helperText,
      margin = _ref.margin,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth,
      helperTextEnabled = _ref.helperTextEnabled,
      options = _ref.options,
      required = _ref.required,
      value = _ref.value,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      menuProps = _ref.menuProps,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'filled' : _ref$variant,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel,
      error = _ref.error,
      id = _ref.id,
      _ref$readonly = _ref.readonly,
      readonly = _ref$readonly === void 0 ? false : _ref$readonly,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      sx = _ref.sx;
  var labelStyleHidden = styles.labelStyleHidden,
      selected = styles.selected;
  var safeId = useSafeId(id);
  var labelId = useSafeId();
  return /*#__PURE__*/React.createElement(FormControl, {
    margin: margin,
    fullWidth: fullWidth,
    disabled: disabled,
    variant: variant,
    className: "FormControl-Select",
    error: error
  }, /*#__PURE__*/React.createElement(InputLabel, {
    id: labelId,
    sx: !showLabel ? labelStyleHidden : undefined,
    required: required
  }, inputLabel), /*#__PURE__*/React.createElement(Select, {
    labelId: labelId,
    id: safeId,
    value: value,
    multiple: true,
    onChange: onChange,
    input: variant === 'filled' ? /*#__PURE__*/React.createElement(FilledInput, null) : variant === 'standard' ? /*#__PURE__*/React.createElement(Input, null) : /*#__PURE__*/React.createElement(OutlinedInput, null),
    renderValue: function renderValue(value) {
      return options.filter(function (option) {
        return value.includes(option.id);
      }).map(function (option) {
        return option.name;
      }).join(', ');
    },
    MenuProps: menuProps,
    IconComponent: ExpandMore,
    className: "Input-Select",
    displayEmpty: true,
    onOpen: onOpen,
    onClose: onClose,
    readOnly: readonly,
    inputProps: {
      readOnly: readonly,
      autoFocus: autoFocus
    },
    sx: sx
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(MenuItem, {
      value: option.id,
      key: option.name,
      "aria-label": option.name,
      sx: selected
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: value && value.indexOf(option.id) > -1
    }), /*#__PURE__*/React.createElement(ListItemText, {
      primary: option.name
    }));
  })), helperTextEnabled && /*#__PURE__*/React.createElement(FormHelperText, null, helperText));
};

CheckboxMultiSelect.displayName = 'CheckboxMultiSelect';
export { CheckboxMultiSelect };